var e,r;function n(){return r?e:(r=1,e=function(e,r){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:r}})}export{n as __require};
//# sourceMappingURL=create-property-descriptor.js.map
